export const buildQueryString = (query: Record<string, string | number>) => {
  const qs = Object.entries(query)
    .filter(pair => pair[1] !== undefined)
    .map(pair =>
      pair
        .filter(i => i !== null)
        .map(encodeURIComponent)
        .join('='),
    )
    .join('&');

  return qs && `?${qs}`;
};
